"use client";

import Image from "next/image";
import Link from "next/link";
import { Eye } from "lucide-react";

import MaskedImage from "../MaskedImage";
import LandingSection from "../LandingSection";

import Straight from "@/public/icon/straight.svg";
import Paye from "@/public/icon/paye.svg";
import Badane from "@/public/icon/badane.svg";
import Lamp from "@/public/icon/lamp.svg";
import YZX from "@/public/icon/yzx.svg";
import { text } from "@/static/text";

import Mirror from "@/public/image/mirror.png";
import { Button } from "@/components/ui/button";

const LABELS_DATA = [
  {
    id: "button",
    title: "دکمه",
    containerClass: "bottom-12 lg:bottom-24 left-[5px] lg:left-[-80px] items-center z-50 lg:items-start ",
    lineClass: "w-[110px] h-[67px] lg:h-[52px] lg:w-[232px]",
    labelClass: ""
  },
  {
    id: "body-bottom",
    title: "بدنه",
    containerClass: "bottom-30 right-0 lg:right-[-100px] items-center lg:items-end",
    lineClass: "w-[110px] h-[67px] lg:h-[52px] lg:w-[232px] rotate-180",
    isReverse: true
  },
  {
    id: "base",
    title: "پایه چرخنده",
    containerClass: "top-[150px] lg:top-[100px] left-[-10px] lg:left-[-160px] items-center lg:items-start z-10 lg:z-40",
    lineClass: "w-[110px] h-[67px] lg:h-[52px] lg:w-[232px] lg:hidden",
    icon: Paye,
    iconWidth: 232,
    iconHeight: 121
  },
  {
    id: "lamp",
    title: "لامپ",
    containerClass: "top-[40px] lg:top-[0px] left-[0px] lg:left-[-130px] items-center lg:items-start",
    lineClass: "w-[70px] h-[67px] lg:h-[52px] lg:w-[232px] lg:hidden",
    icon: Lamp,
    iconWidth: 268,
    iconHeight: 86
  },
  {
    id: "mirror",
    title: "ایینه",
    containerClass: "top-[50px] lg:top-[60px] right-[0px] lg:right-[-110px] items-center lg:items-start flex-row-reverse z-50",
    lineClass: "w-[90px] h-[67px] lg:h-[52px] lg:w-[232px] rotate-180 lg:hidden",
    icon: Badane,
    iconWidth: 233,
    iconHeight: 121,
    labelClass: "mx-2"
  }
];

export default function MirrorSection() {
  return (
    <LandingSection
      tagTitle={text.mirrorSection.tag}
      tagIcon={Eye}
      title={text.mirrorSection.title}
      desc={text.mirrorSection.desc}
      containerClassName="xl:container-4xl"
    >
      <div className="relative h-[420px] lg:h-[600px] w-full text-sm lg:text-base">
        <div className="absolute w-full h-full flex justify-center top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-20">
          <MaskedImage size="lg" className="hidden lg:flex lg:w-[712px] lg:h-[480px] object-contain opacity-20" />
          <MaskedImage size="sm" className="lg:hidden w-full h-full mx-auto object-contain opacity-20" />

          <div className="w-[350px] lg:w-[450px] h-[400px] lg:h-[550px] absolute bottom-1/2 left-1/2 -translate-x-1/2 translate-y-1/2">
            <div className="w-full h-full relative z-20">
              <Image 
                src={Mirror} 
                alt="اینه" 
                className="w-full h-full object-contain relative z-20" 
                quality={75}
              />
            </div>

            {LABELS_DATA.map((item) => (
              <div key={item.id} className={`absolute flex space-x-2 ${item.containerClass}`}>
                {!item.isReverse && <Image src={Straight} alt="" aria-hidden="true" width={232} height={52} className={item.lineClass} />}
                {item.icon && <Image src={item.icon} alt="" aria-hidden="true" width={item.iconWidth || 232} height={item.iconHeight || 121} className="hidden lg:flex" />}
                <div className={`btn-premium-box ${item.labelClass || ""}`}>{item.title}</div>
                {item.isReverse && <Image src={Straight} alt="" aria-hidden="true" width={232} height={52} className={item.lineClass} />}
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="flex w-full justify-center mt-14 lg:mt-0">
        <Link href="https://smartbathroom.ir/product/%D8%A2%DB%8C%DB%8C%D9%86%D9%87-%D8%A7%D8%B5%D9%84%D8%A7%D8%AD-%D8%B1%D9%88%D9%85%DB%8C%D8%B2%DB%8C-5288-322" target="_blank" rel="noopener noreferrer">
          <Button id="show_ar" size={"xl"} variant="berryBorder">
            <Image src={YZX} alt="" aria-hidden="true" width={24} height={24} className="ml-2" />
            مشاهده مدل سه‌بعدی محصول
          </Button>
        </Link>
      </div>
    </LandingSection>
  );
}
